import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_main-layout/')({
  component: IndexRedirect,
})

function IndexRedirect() {
  return <Navigate to="/accounts" />
}
